export const TITLE_ANIMATION_VALUES = {
    duration: 1.5
}

export const DESCRIPTION_ANIMATION_VALUES = {
    duration: 1
}